<template>
    <PopupRouterViewDetail label="Finish Good Quality Inspect Inbox Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Finish Good Quality Inspection Approval" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="model.qtyBefore"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="model.qtyAfter"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-qty-pending" label-cols-lg="12"  label="Qty Pending" label-for="input-qty-pending" size="sm" :model.sync="model.qtyPending"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12"  label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="model.qtyNg"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-radio :options="metodeQcs" text-field="name" value-field="id" label-cols-lg="12" label="Metode Qc" id="fieldset-metode-qc" size="sm" :model.sync="model.metodeQcId"  @change="updateData" :isUpdatable ="true"/>
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Work Order Process Detail" id="fieldset-work-order-process-detail" size="sm" :model.sync="model.workOrderProcessDetailId"   :selected="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.part : ''" @input="getWorkOrderProcessDetails" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderProcessDetail" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Finish Good Quality Inspection NG" :bordered="true" :items="finishGoodQualityInspectNgInboxs" :fields="fieldsFinishGoodQualityInspectNgInbox" :busy="isDataLoading" :sort-by.sync="sortByFinishGoodQualityInspectNgInbox" :sort-desc.sync="sortDescFinishGoodQualityInspectNgInbox" small responsive
			@editButtonMethod="editRowDataFinishGoodQualityInspectNgInbox"
			@deleteButtonMethod="deleteRowDataFinishGoodQualityInspectNgInbox"
			@showPopupAddMethod="resetDataFinishGoodQualityInspectNgInbox()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQualityInspectNgInbox()"
			@downloadMethod="downloadFinishGoodQualityInspectNgInbox()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQualityInspectNgInbox()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQualityInspectNgInbox()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadFinishGoodQualityInspectNgInbox"
			>
			<template #top-row v-if="isShowFinishGoodQualityInspectNgInboxFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Problem Category">
					<v-select append-to-body label="code" :options="problemCategorys"  :value="filterFinishGoodQualityInspectNgInbox.problemCategoryId" :reduce="item => item.id" v-model="filterFinishGoodQualityInspectNgInbox.problemCategoryId" @search="getProblemCategorys" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="QtyNg">
					<b-form-input id="input-qty-ng-table" v-model="filterFinishGoodQualityInspectNgInbox.qtyNg" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( finishGoodQualityInspectNgInboxPageSize * (currentFinishGoodQualityInspectNgInboxPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(problemCategory)="row">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="code" optionsKey="id" :id="'input-finish-good-quality-inspect-ng-inboxs-problem-category-' + row.index" label-cols-lg="12" label="Problem Category" size="sm" :model.sync="row.item.problemCategoryId"  @change="saveInputFinishGoodQualityInspectNgInbox(row.item)" :selected="row.item.problemCategory != null ? row.item.problemCategory.code : ''"  @input="getProblemCategorys" :loading="isProblemCategoryComboLoading"  :isUpdatable="true"  :nolabel="true" />
			</template>
			<template v-slot:cell(qtyNg)="row">
				<app-input-textbox :id="'input-finish-good-quality-inspect-ng-inboxs-qty-ng-' + row.index" label-cols-lg="12" label="QtyNg" size="sm" :model.sync="row.item.qtyNg" :state="validateState('qtyNg')" :errorMessage="getErrorMessage(errorMessage.qtyNg, 'qtyNg')"   @change="saveInputFinishGoodQualityInspectNgInbox(row.item)" :isUpdatable="true"  :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<FinishGoodQualityInspectNgInboxInput 
					:openPopup="isShowPopupFinishGoodQualityInspectNgInbox"
					:modelId="finishGoodQualityInspectNgInboxId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQualityInspectNgInbox"/>
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQualityInspectNgInboxUpload
					:openPopup="isShowPopupUploadFinishGoodQualityInspectNgInbox"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataFinishGoodQualityInspectNgInbox"
					:parentId="modelId"
					/>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQualityInspectInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInbox';
import FinishGoodQualityInspectInboxList from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxList';
import FinishGoodQualityInspectInboxFilter from '@/filters/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInboxFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputRadio from '@/components/AppInputRadio';
import MetodeQc from '@/models/MetodeQc/MetodeQc';
import MetodeQcFilter from '@/filters/MetodeQc/MetodeQcFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import FinishGoodQualityInspectNgInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInbox';
import FinishGoodQualityInspectNgInboxFilter from '@/filters/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInboxFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import FinishGoodQualityInspectNgInboxInput from '@/views/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInboxInput';
import FinishGoodQualityInspectNgInboxUpload from '@/views/FinishGoodQualityInspectInbox/FinishGoodQualityInspectNgInboxUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputRadio,
		FinishGoodQualityInspectNgInboxInput,FinishGoodQualityInspectNgInboxUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsFinishGoodQualityInspectNgInbox: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"problemCategory": { "class" : "th-problem-category first-child", "label" : "Problem Category", key: 'problemCategory', sortable: false}}, 
				{"qtyNg": { "class" : "th-qty-ng", "label" : "QtyNg", key: 'qtyNg', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelFinishGoodQualityInspectNgInbox : {},
			isShowPopupFinishGoodQualityInspectNgInbox : false,
			isShowPopupUploadFinishGoodQualityInspectNgInbox : false,
			filterFinishGoodQualityInspectInbox : null,
			currentFinishGoodQualityInspectInboxPage : 1,
			finishGoodQualityInspectInboxPageSize: 10,
			sortByFinishGoodQualityInspectInbox: '',
			sortDescFinishGoodQualityInspectInbox: '',
			filterFinishGoodQualityInspectNgInbox : null,
			currentFinishGoodQualityInspectNgInboxPage : 1,
			finishGoodQualityInspectNgInboxPageSize: 10,
			sortByFinishGoodQualityInspectNgInbox: '',
			sortDescFinishGoodQualityInspectNgInbox: '',
			sortingByFinishGoodQualityInspectNgInbox: [],
			finishGoodQualityInspectNgInboxs : [],
			finishGoodQualityInspectNgInboxId : '',
			totalFinishGoodQualityInspectNgInboxRow : 0,
			isShowFinishGoodQualityInspectNgInboxFilter: false,
			isDownloadFinishGoodQualityInspectNgInbox: false,
			problemCategorys: [],
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			metodeQcs: [],
			metodeQcs: [],
			isMetodeQcComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			workOrderProcessDetails: [],
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isMetodeQcComboLoading: false,
			isPartComboLoading: false,
			isWorkOrderProcessDetailComboLoading: false,
			isProblemCategoryComboLoading: false,
			isFinishGoodQualityInspectInboxComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getFinishGoodQualityInspectInbox : async function(id) {
			this.isBusy = true;
			FinishGoodQualityInspectInbox.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQualityInspectInbox = true;
			this.filterFinishGoodQualityInspectInbox.id = this.modelId;
			FinishGoodQualityInspectInbox.downloadDataDetail(this, this.filterFinishGoodQualityInspectInbox).then(result => {
				this.isDownloadFinishGoodQualityInspectInbox = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectInbox = false; })
		},
		getFinishGoodQualityInspectNgInboxs : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQualityInspectNgInbox);
			if (this.modelId == null) return;
			filter.finishGoodQualityInspectInboxId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByFinishGoodQualityInspectNgInbox != null) {
				this.sortingByFinishGoodQualityInspectNgInbox[this.sortByFinishGoodQualityInspectNgInbox] = this.sortDescFinishGoodQualityInspectNgInbox;
			}
			let currentPage = (this.currentFinishGoodQualityInspectNgInboxPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQualityInspectNgInboxRow + 1;
				let page = Math.ceil(totalData/this.finishGoodQualityInspectNgInboxPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQualityInspectNgInboxPageSize = 0;
			// disable paging end
			FinishGoodQualityInspectNgInbox.getList(this, filter, this.sortingByFinishGoodQualityInspectNgInbox, currentPage , this.finishGoodQualityInspectNgInboxPageSize).then(result => {
				this.currentFinishGoodQualityInspectNgInboxPage = currentPage + 1;
				this.finishGoodQualityInspectNgInboxs = result.data;
				this.totalFinishGoodQualityInspectNgInboxRow = result.dataCount;
			}).catch(error => {});
		},
		getFinishGoodQualityInspectInboxs : async function(input) {
			let filter = new FinishGoodQualityInspectInboxFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isFinishGoodQualityInspectInboxComboLoading = true;
			FinishGoodQualityInspectInbox.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspectInboxs = result.data
				}
				this.isFinishGoodQualityInspectInboxComboLoading = false;
			})
			.catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isProblemCategoryComboLoading = true;
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
				this.isProblemCategoryComboLoading = false;
			})
			.catch(error => {});
		},
		getFinishGoodQualityInspectInboxs : async function(input) {
			let filter = new FinishGoodQualityInspectInboxFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isFinishGoodQualityInspectInboxComboLoading = true;
			FinishGoodQualityInspectInbox.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspectInboxs = result.data
				}
				this.isFinishGoodQualityInspectInboxComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMetodeQcs : async function(input) {
			let filter = new MetodeQcFilter();
			if (input != undefined) {
				filter.name = input;
			}
			MetodeQc.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.metodeQcs = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedMetodeQc(item) {
			if(item == undefined || item == null) {
				this.model.metodeQcId = null;
				this.model.metodeQc = null;
			} else {
				this.model.metodeQcId = item.id;
				this.model.metodeQc = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.finishGoodQualityInspectInboxInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectInbox.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqualityinspectinboxindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					FinishGoodQualityInspectInbox.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqualityinspectinboxindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectInbox.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getFinishGoodQualityInspectInbox(id);
					});
				}
			});
		},
		onHidden() {
			this.getFinishGoodQualityInspectInboxs();
		},
		addRowDataFinishGoodQualityInspectNgInbox(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQualityInspectInboxId =  this.modelId;
					FinishGoodQualityInspectNgInbox.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getFinishGoodQualityInspectNgInboxs(true);
						this.isShowPopupFinishGoodQualityInspectNgInbox = false;
					})
				} else {
					model.finishGoodQualityInspectInboxId =  this.modelId;
					FinishGoodQualityInspectNgInbox.createDataDetail(this, model)
					.then(result => {
						this.getFinishGoodQualityInspectNgInboxs(true);
						this.isShowPopupFinishGoodQualityInspectNgInbox = false;
					})
				}
			}
		},
		async editRowDataFinishGoodQualityInspectNgInbox(id) {
			this.finishGoodQualityInspectNgInboxId = id;
			this.isShowPopupFinishGoodQualityInspectNgInbox = true; 
		},
		async deleteRowDataFinishGoodQualityInspectNgInbox(id) {
			FinishGoodQualityInspectNgInbox.deleteData(this, id).then(result => { this.getFinishGoodQualityInspectNgInboxs(); });
		},
		async resetDataFinishGoodQualityInspectNgInbox() {
			this.finishGoodQualityInspectNgInboxId = "";
			this.isShowPopupFinishGoodQualityInspectNgInbox = true;
		},
		async addDataFinishGoodQualityInspectNgInbox() {
			FinishGoodQualityInspectNgInbox.createData(this, { finishGoodQualityInspectInboxId: this.modelId })
			.then(result => {
				this.getFinishGoodQualityInspectNgInboxs(true);
			})
		},
		async addFromClipboardFinishGoodQualityInspectNgInbox() {
			let qtyNgs = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					qtyNgs.push({ qtyNg: item, finishGoodQualityInspectInboxId: this.modelId });
				});
				FinishGoodQualityInspectNgInbox.addFromClipboard(this, qtyNgs).then(result => { this.getFinishGoodQualityInspectNgInboxs() });
			});
		},
		async replaceFromClipboardFinishGoodQualityInspectNgInbox() {
			let qtyNgs = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					qtyNgs.push({ qtyNg: item, finishGoodQualityInspectInboxId: this.modelId });
				});
				FinishGoodQualityInspectNgInbox.replaceFromClipboard(this, qtyNgs).then(result => { this.getFinishGoodQualityInspectNgInboxs() });
			});   
		},
		showPopupUploadFinishGoodQualityInspectNgInbox() {
			if(this.finishGoodQualityInspectNgInboxs != null && this.finishGoodQualityInspectNgInboxs.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap FinishGoodQualityInspectNgInbox akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadFinishGoodQualityInspectNgInbox = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadFinishGoodQualityInspectNgInbox = true;
			}
		},
		uploadDataFinishGoodQualityInspectNgInbox(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQualityInspectNgInbox = false; 
		},
		downloadFinishGoodQualityInspectNgInbox(modalEvent) {
			this.isDownloadFinishGoodQualityInspectNgInbox = true;
			this.filterFinishGoodQualityInspectNgInbox.finishGoodQualityInspectInboxId = this.modelId;
			FinishGoodQualityInspectNgInbox.downloadDataDetail(this, this.filterFinishGoodQualityInspectNgInbox).then(result => {
				this.isDownloadFinishGoodQualityInspectNgInbox = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectNgInbox = false; })
		},
		saveInputFinishGoodQualityInspectNgInbox(item) {
			if (this.problemCategorys != null && this.problemCategorys != undefined  && this.problemCategorys.length > 0) {
				item.problemCategory = this.problemCategorys.find(q => q.id == item.problemCategoryId);
			}
			if (this.finishGoodQualityInspectInboxs != null && this.finishGoodQualityInspectInboxs != undefined  && this.finishGoodQualityInspectInboxs.length > 0) {
				item.finishGoodQualityInspectInbox = this.finishGoodQualityInspectInboxs.find(q => q.id == item.finishGoodQualityInspectInboxId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectNgInbox.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadFinishGoodQualityInspectNgInbox = false; 
			this.isShowPopupFinishGoodQualityInspectNgInbox = false; 
			if (modalType == 'FinishGoodQualityInspectNgInbox') {
				this.getFinishGoodQualityInspectNgInboxs();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowFinishGoodQualityInspectNgInboxFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterFinishGoodQualityInspectInbox = new FinishGoodQualityInspectInboxFilter();
		this.filterFinishGoodQualityInspectNgInbox = new FinishGoodQualityInspectNgInboxFilter();
		//this.getProblemCategorys();
		//this.getFinishGoodQualityInspectInboxs();
		//this.getControlCards();
		this.getMetodeQcs();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getFinishGoodQualityInspectInbox(id);
			} else {
				this.modelId = id;
				this.getFinishGoodQualityInspectInbox(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByFinishGoodQualityInspectNgInbox : {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		sortDescFinishGoodQualityInspectNgInbox: {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		currentFinishGoodQualityInspectNgInboxPage: {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		finishGoodQualityInspectNgInboxPageSize : {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			}
		},
		filterFinishGoodQualityInspectNgInbox: {
			handler: function() {
				this.getFinishGoodQualityInspectNgInboxs();
			},
			deep: true,
		},
	},
}
</script>
